var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapricorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12pt",
    height: "12pt",
    viewBox: "0 0 12 12",
    id: "svg9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 80.398438 V 80.398438 H 0 Z m 0,0",
    id: "path2-5"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.14925,0,0,0.14925,-0.14973342,2.6657917e-4)",
    id: "surface1",
    style: {
      stroke: "#000000",
      strokeWidth: 4.0201005,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeLinejoin: "round",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 4.0201005,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeLinejoin: "round",
      strokeLinecap: "round"
    },
    clipPath: "url(#clip1)",
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40.20100503,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 66.992188,513.6875 H 178.67187 L 290.3125,67.007812 401.99219,513.6875 H 625.3125 c 61.67969,0 111.67969,49.96094 111.67969,111.64062 0,19.60938 -5.15625,38.86719 -14.96094,55.85938 -19.92188,34.53125 -56.79688,55.82031 -96.71875,55.82031 -61.64063,0 -111.64063,-50 -111.64063,-111.67969 0,-19.60937 5.15625,-38.86718 14.96094,-55.82031 l 193.39844,-335 c 9.80469,-16.99219 14.96094,-36.25 14.96094,-55.82031 0,-61.67969 -50,-111.679688 -111.67969,-111.679688 -61.64063,0 -111.64063,49.999998 -111.64063,111.679688",
    transform: "matrix(0.1,0,0,-0.1,0,80.4)",
    id: "path7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapricorn);
export default __webpack_public_path__ + "static/media/capricorn.728814f74773d6318df069c39af7b736.svg";
export { ForwardRef as ReactComponent };